(function () {
  function reorder() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.dataset.mobileSecondMediaMoved === 'true') return;

    var sliderComponent = gallery.querySelector('slider-component');
    var slider = gallery.querySelector('.product__media-list.slider--mobile');
    if (!slider) return;

    var slides = Array.prototype.slice.call(slider.children).filter(function (el) {
      return el.classList && el.classList.contains('product__media-item');
    });

    if (slides.length < 3) return;

    var secondSlide = slides[1];
    slider.appendChild(secondSlide);
    gallery.dataset.mobileSecondMediaMoved = 'true';

    // Rebuild Dawn/Shopify slider internals so counter uses the new DOM order.
    if (sliderComponent) {
      sliderComponent.sliderItems = Array.prototype.slice.call(
        slider.querySelectorAll('.product__media-item')
      );

      if (typeof sliderComponent.initPages === 'function') {
        sliderComponent.initPages();
      }

      if (typeof sliderComponent.update === 'function') {
        sliderComponent.update();
      }

      if (sliderComponent.currentPageElement) {
        sliderComponent.currentPageElement.textContent = '1';
      }
    }

    window.dispatchEvent(new Event('resize'));
  }

  // Run after theme components initialize.
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(reorder, 80);
    setTimeout(reorder, 350);
    setTimeout(reorder, 900);
  });

  window.addEventListener('load', function () {
    setTimeout(reorder, 80);
  });
})();
